module.exports = __webpack_public_path__ + "img/hr-dry-tree-07.4d2cf4b5.png";